
const newModel = () => {
    return {
        diemTienIchId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        tenPhuongXa: null,
        phuongXaId: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        gioiThieu: null,
        gioMoCua: null,
        loaiDiadiemId: null,
        tenLoaiDiadiem: null,
        tenPhanloaiDiadiem: null,
        phanloaiDiadiemId: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null

    }
}

const newFEModel = () => {
    return {
        diemTienIchId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        tenPhuongXa: null,
        phuongXaId: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        gioiThieu: null,
        gioMoCua: null,
        loaiDiadiemId: null,
        tenLoaiDiadiem: null,
        tenPhanloaiDiadiem: null,
        phanloaiDiadiemId: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        diemTienIchId: item.diemTienIchId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        tenPhuongXa: item.tenPhuongXa,
        phuongXaId: item.phuongXaId,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        gioiThieu: item.gioiThieu,
        gioMoCua: item.gioMoCua,
        loaiDiadiemId: item.loaiDiadiemId,
        tenLoaiDiadiem: item.tenLoaiDiadiem,
        tenPhanloaiDiadiem: item.tenPhanloaiDiadiem,
        phanloaiDiadiemId: item.phanloaiDiadiemId,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        diemTienIchId: item.diemTienIchId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        phuongXaId: item.phuongXaId,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        gioiThieu: item.gioiThieu,
        gioMoCua: item.gioMoCua,
        loaiDiadiemId: item.loaiDiadiemId,
        phanloaiDiadiemId: item.phanloaiDiadiemId,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ten: null,
        phanloaiDiadiemId: null,
        phuongXaId: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        ten: item.ten,
        phanloaiDiadiemId: item.phanloaiDiadiemId,
        phuongXaId: item.phuongXaId,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        diemTienIchId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        phuongXaId: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        gioiThieu: null,
        gioMoCua: null,
        loaiDiadiemId: null,
        phanloaiDiadiemId: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

export const diemTienIchModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}


